






import { Component, Mixins } from 'vue-property-decorator'
import AdminHeader from '@/components/organisms/AdminHeader.vue'
import BootstrapLoader from '@/components/atoms/BootstrapLoader.vue'

@Component({
  components: {
    AdminHeader,
  },
})
export default class AdminLayout extends Mixins(BootstrapLoader) {
  private toggleBodyClass(addRemoveClass: string, className: string): void {
    const el = document.body

    if (addRemoveClass === 'addClass') {
      el.classList.add(className)
    } else {
      el.classList.remove(className)
    }
  }

  private mounted(): void {
    this.loadBootstrap()
    this.toggleBodyClass('addClass', 'admin')
  }

  private destroyed(): void {
    this.unloadBootstrap()
    this.toggleBodyClass('removeClass', 'admin')
  }
}
